import React from "react";

function HoverModalContent({ cell }) {
  return (
    <div className="hover-modal-content">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
        }}
      >
        <div
          className="column-1"
          style={
            window.matchMedia("(max-width: 480px)").matches
              ? { textAlign: "right" }
              : null
          }
        >
          <div>Longbow Core Signal</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Core Signal Strength Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] ===
              "Buy"
                ? "green"
                : cell.row.original.algo.data[
                    "CALC_POSITION_LONGBOW_SIGNAL"
                  ] === "Sell"
                ? "red"
                : cell.row.original.algo.data[
                    "CALC_POSITION_LONGBOW_SIGNAL"
                  ] === "No Action" ||
                  cell.row.original.algo.data[
                    "CALC_POSITION_LONGBOW_SIGNAL"
                  ] === "Hold"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["CALC_POSITION_LONGBOW_SIGNAL"]
              ? cell.row.original.algo.data["CALC_POSITION_LONGBOW_SIGNAL"] ===
                "Buy"
                ? "Long"
                : cell.row.original.algo.data[
                    "CALC_POSITION_LONGBOW_SIGNAL"
                  ] === "Sell"
                ? "Short"
                : "Neutral"
              : "- - -"}
          </div>
        </div>

        <div>Core Signal Strength</div>
        <div></div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div>Signal Odds</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Signal Odds Pill */}
          <div
            className={`indicator-pill ${
              !cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS
                ? "empty-value"
                : cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS >= 0
                ? "green"
                : cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS < 0
                ? "red"
                : "grey"
            }-background`}
          >
            {cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS
              ? cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS.toFixed(1)
              : "- - -"}
          </div>
        </div>

        <div>High/Medium/Low</div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 15,
        }}
      >
        <div className="column-1">
          <div>Range Signal</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Range Signal Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] === "Buy"
                ? "green"
                : cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                  "Sell"
                ? "red"
                : cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                    "Hold" ||
                  cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                    "No Action"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"]
              ? cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                "Buy"
                ? "Oversold"
                : cell.row.original.algo.data["CALC_TRADING_RANGE_SIGNAL"] ===
                  "Sell"
                ? "Overbought"
                : "Neutral"
              : "- - -"}
          </div>
        </div>

        <div>
          {window.matchMedia("(max-width: 480px)").matches
            ? "Overbought/ Oversold"
            : "Overbought/Oversold"}
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Asymmetry Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS > 0
                ? "green"
                : cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS < 0
                ? "red"
                : cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS === 0
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS > 0
              ? "Bullish"
              : cell.row.original.algo.data.CALC_TRADE_RANGE_ODDS < 0
              ? "Bearish"
              : "- - -"}
          </div>
        </div>

        <div className="column-3">Asymmetry</div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Low End of Trading Range Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo_daily_kiss_low === "Higher"
                ? "green"
                : cell.row.original.algo_daily_kiss_low === "Lower"
                ? "red"
                : cell.row.original.algo_daily_kiss_low === "Neutral"
                ? "grey"
                : "grey empty-value"
            }-background`}
          >
            {cell.row.original.algo_daily_kiss_low
              ? cell.row.original.algo_daily_kiss_low
              : "- - -"}
          </div>
        </div>

        <div className="column-3">Low End of the TR</div>
        <div className="column-4"></div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* High End of Trading Range Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo_daily_kiss_high === "Higher"
                ? "green"
                : cell.row.original.algo_daily_kiss_high === "Lower"
                ? "red"
                : cell.row.original.algo_daily_kiss_high === "Neutral"
                ? "grey"
                : "grey empty-value"
            }-background`}
          >
            {cell.row.original.algo_daily_kiss_high
              ? cell.row.original.algo_daily_kiss_high
              : "- - -"}
          </div>
        </div>

        <div className="column-3">High End of the TR</div>
        <div className="column-4"></div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 15,
        }}
      >
        <div className="column-1">
          <div>Short Term Signals</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Short Term Momentum Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["30D_ST_MOMENTUM"] === "BULLISH"
                ? "green"
                : cell.row.original.algo.data["30D_ST_MOMENTUM"] === "BEARISH"
                ? "red"
                : cell.row.original.algo.data["30D_ST_MOMENTUM"] === "NEUTRAL"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["30D_ST_MOMENTUM"]
              ? cell.row.original.algo.data["30D_ST_MOMENTUM"][0] +
                cell.row.original.algo.data["30D_ST_MOMENTUM"]
                  .slice(1)
                  .toLowerCase()
              : "- - -"}
          </div>
        </div>

        <div className="column-3">Momentum</div>
        <div className="column-4"></div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* 3D Momentum Pill */}
          <div
            style={{ textTransform: "capitalize" }}
            className={`indicator-pill ${
              cell.row.original.algo.data["30D_ST_MOMENTUM_3D"] === "BULLISH"
                ? "green"
                : cell.row.original.algo.data["30D_ST_MOMENTUM_3D"] ===
                  "BEARISH"
                ? "red"
                : cell.row.original.algo.data["30D_ST_MOMENTUM_3D"] ===
                  "NEUTRAL"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["30D_ST_MOMENTUM_3D"]
              ? cell.row.original.algo.data["30D_ST_MOMENTUM_3D"].toLowerCase()
              : "- - -"}
          </div>
        </div>

        <div className="column-3">3D Momentum</div>
        <div className="column-4"></div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Premium/Discount Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["IVOL_SIGNAL"] === "Greed"
                ? "red"
                : cell.row.original.algo.data["IVOL_SIGNAL"] === "Fear"
                ? "green"
                : cell.row.original.algo.data["IVOL_SIGNAL"] === "Neutral"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["IVOL_SIGNAL"] &&
            cell.row.original.algo.data["IVOL_SIGNAL"] !== "NA"
              ? cell.row.original.algo.data["IVOL_SIGNAL"] === "Greed"
                ? "Discount"
                : cell.row.original.algo.data["IVOL_SIGNAL"] === "Fear"
                ? "Premium"
                : "Neutral"
              : "- - -"}
          </div>
        </div>

        <div className="column-3">Premium / (Discount)</div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* -1W Premium/Discount */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["IVOL_1WK_CHECK"] === "Bullish"
                ? "green"
                : cell.row.original.algo.data["IVOL_1WK_CHECK"] === "Bearish"
                ? "red"
                : cell.row.original.algo.data["IVOL_1WK_CHECK"] === "Neutral"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["IVOL_1WK_CHECK"]
              ? cell.row.original.algo.data["IVOL_1WK_CHECK"] === "Bullish"
                ? "Premium"
                : cell.row.original.algo.data["IVOL_1WK_CHECK"] === "Bearish"
                ? "Discount"
                : "Neutral"
              : "- - -"}
          </div>
        </div>

        <div className="column-3">-1W Premium / (Discount)</div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 15,
        }}
      >
        <div
          className="column-1"
          style={
            window.matchMedia("(max-width: 480px)").matches
              ? { textAlign: "right" }
              : null
          }
        >
          <div>Medium Term Signals</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Medium Term Momentum Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["90D_MT_MOMENTUM"] === "BULLISH"
                ? "green"
                : cell.row.original.algo.data["90D_MT_MOMENTUM"] === "BEARISH"
                ? "red"
                : cell.row.original.algo.data["90D_MT_MOMENTUM"] === "NEUTRAL"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["90D_MT_MOMENTUM"] === "BULLISH"
              ? "Bullish"
              : cell.row.original.algo.data["90D_MT_MOMENTUM"] === "BEARISH"
              ? "Bearish"
              : cell.row.original.algo.data["90D_MT_MOMENTUM"] === "NEUTRAL"
              ? "Neutral"
              : "- - -"}
          </div>
        </div>

        <div className="column-3">Momentum</div>
        <div className="column-4"></div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      >
        <div className="column-1">
          <div></div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* -3M Premium/Discount Pill */}
          <div
            className={`indicator-pill ${
              cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Bullish"
                ? "green"
                : cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Bearish"
                ? "red"
                : cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Neutral"
                ? "grey"
                : "empty-value"
            }-background`}
          >
            {cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Bullish"
              ? "Premium"
              : cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Bearish"
              ? "Discount"
              : cell.row.original.algo.data["IVOL_3MO_CHECK"] === "Neutral"
              ? "Neutral"
              : "- - -"}
          </div>
        </div>

        <div className="column-3">-3M Premium / (Discount)</div>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: window.matchMedia("(max-width: 480px)").matches
            ? "37% 27% 31% .5%"
            : "40% 10% 25% 25%",
          marginTop: 3,
        }}
      ></div>
    </div>
  );
}
export default React.memo(HoverModalContent);
